export default __webpack_public_path__ + "static/media/1087.37089f63.png";